import React from 'react'
import { connect } from 'react-redux'

const Spinner = ({ on }) => (
  on ? (
    <div 
      style={{position: "fixed", zIndex: 50,  right: 15, top: 60 }}
    >
      <div className="loading">
        <div className="outer"></div>
        <div className="inner"></div>
      </div>     
    </div>
  ) : (
  <span></span>
  )
)

const changesRE = /^(changed|created|removed).*/

function thereAreChanges(persistence) {
  for (let prop in persistence) 
    if (changesRE.test(prop) && persistence[prop].length > 0) 
      return true
  
  return false  
}

const stateToProps = (state) => ({
  on: state.persistence.dirty || state.persistence.saving || thereAreChanges(state.persistence) 
})

const dispatchToProps = (dispatch) => ({})

export default connect(stateToProps, dispatchToProps)(Spinner)
